import { render, staticRenderFns } from "./dc1.vue?vue&type=template&id=ab74ae96&scoped=true&"
import script from "./dc1.vue?vue&type=script&lang=js&"
export * from "./dc1.vue?vue&type=script&lang=js&"
import style0 from "./dc1.vue?vue&type=style&index=0&id=ab74ae96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab74ae96",
  null
  
)

export default component.exports